import React from 'react';

export default function ParticularsTable() {
  const data = [
    // Particulars section
    { 
      section: 'Particulars', 
      items: [
        { id: '1', description: 'CTC (Cost to Company)', link: 'Click Here' },
        { id: '2', description: 'CTC Details and statement of PO', link: 'Click Here' },
        { id: '3', description: 'CTC - OOA segment of IPO', link: 'Click Here' },
        { id: '4', description: 'Circular', link: 'Click Here' }
      ]
    },
    // Current/Consent section
    { 
      section: 'Current/Consent', 
      items: [
        { id: '1', description: 'Consent Letter from Chief Financial Officer (CFO) Goodla Seshi Gangirell', link: 'Click Here' },
        { id: '2', description: 'Consent Letter from Chief Audit/Risk Executive Sangheli', link: 'Click Here' },
        { id: '3', description: 'Consent Letter from Company Secretary I joi I National Mobile & Export', link: 'Click Here' },
        { id: '4', description: 'Consent Letter from Registrars Hoya Rhowlt Limited', link: 'Click Here' },
        { id: '5', description: 'Consent Letter from Registrars Hoya Bansali Securities', link: 'Click Here' },
        { id: '6', description: 'Consent Letter from Directors Indian Bullion Vishwamargamel', link: 'Click Here' },
        { id: '7', description: 'Consent Letter From WTG Handle Degh Sangheli', link: 'Click Here' }
      ]
    },
    // Due Diligence section
    { 
      section: 'Due Diligence', 
      items: [
        { id: '1', description: 'Chartered Engineering Certificate (cost content)', link: 'Click Here' },
        { id: '2', description: 'Bank content - Canara', link: 'Click Here' },
        { id: '3', description: 'Complaint Undertaking - Sindell, BC', link: 'Click Here' },
        { id: '4', description: 'Undertaker Consent', link: 'Click Here' },
        { id: '5', description: 'Business consent B5', link: 'Click Here' },
        { id: '6', description: 'Complaint Sankel (GBC', link: 'Click Here' },
        { id: '7', description: 'Complaint (Journal Market Share) CC', link: 'Click Here' },
        { id: '8', description: 'Complaint letter Debt Auditor', link: 'Click Here' },
        { id: '9', description: 'Banker on Issues Private Auc (Bombinsi) Ltd', link: 'Click Here' },
        { id: '10', description: 'Complaint Jurisdiction Sangatri BC', link: 'Click Here' }
      ]
    },
    // Company Current sent [sic] section
    { 
      section: 'Company Current sent [sic]', 
      items: [
        { id: '1', description: 'Bora RoC Officer', link: 'Click Here' }
      ]
    },
    // Documents of Selling Shareholders section
    { 
      section: 'Documents of Selling Shareholders', 
      items: [
        { id: '1', description: 'OA (FDI) Sangheli', link: 'Click Here' },
        { id: '2', description: 'OPD Limited', link: 'Click Here' },
        { id: '3', description: 'OPD Handle Sangheti', link: 'Click Here' }
      ]
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto bg-white border border-gray-300">
      {data.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          {/* Section Header */}
          <div className="bg-red-600 text-white text-sm font-medium px-3 py-2 border-b border-gray-300">
            <div className="flex">
              <div className="w-12"></div>
              <div className="flex-1">{section.section}</div>
              <div className="w-20 text-center">Link</div>
            </div>
          </div>
          
          {/* Section Items */}
          {section.items.map((item, itemIndex) => (
            <div key={itemIndex} className="bg-white border-b border-gray-300 text-xs">
              <div className="flex">
                <div className="w-12 px-3 py-2 text-center border-r border-gray-300">
                  {item.id}
                </div>
                <div className="flex-1 px-3 py-2 border-r border-gray-300">
                  {item.description}
                </div>
                <div className="w-20 px-3 py-2 text-center">
                  <button className="text-red-600 hover:text-red-800 hover:underline">
                    {item.link}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}